import { atom } from 'jotai';

export const uiStateAtomSearchClicked = atom(false);
